import "../sentry-client";

import "./styles/vars.css";
import "./styles/globals.css";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import App from "./App";

const { coreData, pageData, pathName } = window.API_DATA || {};

hydrateRoot(
  document.getElementById("root"),
  <StrictMode>
    <App coreData={coreData} pageData={pageData} pathName={pathName} />
  </StrictMode>,
);
